module.exports = __webpack_public_path__ + "media/images/logo-otec-manager-01-02eea059ce2d1a34830cdad0d23f8921.svg";